// extracted by mini-css-extract-plugin
export default {"page":"ProductsPage_page__rgYlD"};